class SaleCountdown {
  constructor(options) {
    this.selectors = {
      days: "#sale-countdown-days",
      hours: "#sale-countdown-hours",
      minutes: "#sale-countdown-minutes",
      seconds: "#sale-countdown-seconds",
      daysLabel: "#days-label",
      hoursLabel: "#hours-label",
      minutesLabel: "#minutes-label",
      secondsLabel: "#seconds-label",
    };
    this.options = options || {};
    this.isInThemeEditor =
      Shopify.designMode || (window.Shopify && window.Shopify.theme && window.Shopify.theme.role === "unpublished");
    this.resolveTargetDate();
    this.init();
  }
  resolveTargetDate() {
    const durationMs = (parseFloat(this.options.durationHours) || 17) * 3600 * 1000;
    if (this.isInThemeEditor) {
      // Always show a fresh full-length countdown in the theme editor, don't persist it.
      this.targetDate = new Date(Date.now() + durationMs);
      return;
    }
    const storageKey = "sale_countdown_target_ts";
    const storedTs = parseInt(localStorage.getItem(storageKey), 10);
    if (!isNaN(storedTs) && storedTs > Date.now()) {
      // Keep counting down toward the deadline already shown to this visitor,
      // so a page refresh doesn't push the timer back out.
      this.targetDate = new Date(storedTs);
    } else {
      // No stored deadline, or it already passed: start a new countdown cycle from right now.
      this.targetDate = new Date(Date.now() + durationMs);
      localStorage.setItem(storageKey, String(this.targetDate.getTime()));
    }
  }
  init() {
    this.daysElement = document.querySelector(this.selectors.days);
    this.hoursElement = document.querySelector(this.selectors.hours);
    this.minutesElement = document.querySelector(this.selectors.minutes);
    this.secondsElement = document.querySelector(this.selectors.seconds);
    this.initLabels();
    this.updateCountdown();
    setInterval(() => this.updateCountdown(), 1000);
  }
  initLabels() {
    // Labels always reflect the section's current settings; they are not persisted
    // in localStorage (only the countdown deadline is), so editing them in the
    // theme always takes effect for every visitor on the next page load.
    if (this.options.showDays) {
      const daysLabelElement = document.querySelector(this.selectors.daysLabel);
      if (daysLabelElement) daysLabelElement.textContent = this.options.daysLabel;
    }
    const labels = [
      { selector: this.selectors.hoursLabel, defaultValue: this.options.hoursLabel },
      { selector: this.selectors.minutesLabel, defaultValue: this.options.minutesLabel },
      { selector: this.selectors.secondsLabel, defaultValue: this.options.secondsLabel },
    ];
    labels.forEach((label) => {
      const element = document.querySelector(label.selector);
      if (element) element.textContent = label.defaultValue;
    });
  }
  updateCountdown() {
    let timeDifference;
    if (this.options.customEndTime) {
      let now = new Date();
      timeDifference = this.targetDate - now;
      if (timeDifference <= 0) {
        if (this.isInThemeEditor) {
          this.setZeroValues();
          return;
        }
        // Deadline passed: start a new cycle immediately instead of freezing at zero.
        this.resolveTargetDate();
        now = new Date();
        timeDifference = this.targetDate - now;
      }
    } else {
      const now = new Date();
      const estMidnight = new Date();
      const isDST = function () {
        const jan = new Date(now.getFullYear(), 0, 1).getTimezoneOffset();
        const jul = new Date(now.getFullYear(), 6, 1).getTimezoneOffset();
        return Math.max(jan, jul) !== now.getTimezoneOffset();
      };
      estMidnight.setUTCHours(isDST() ? 4 : 5, 0, 0, 0);
      estMidnight.setUTCDate(estMidnight.getUTCDate() + 1);
      timeDifference = estMidnight - now;
      if (timeDifference <= 0) {
        estMidnight.setUTCDate(estMidnight.getUTCDate() + 1);
        timeDifference = estMidnight - now;
      }
    }
    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
    this.displayTimeValues(days, hours, minutes, seconds);
  }
  setZeroValues() {
    if (this.options.showDays && this.daysElement) {
      this.daysElement.textContent = this.options.zeroValue;
    }
    if (this.hoursElement) this.hoursElement.textContent = this.options.zeroValue;
    if (this.minutesElement) this.minutesElement.textContent = this.options.zeroValue;
    if (this.secondsElement) this.secondsElement.textContent = this.options.zeroValue;
  }
  displayTimeValues(days, hours, minutes, seconds) {
    const formatDigits = (num) => {
      return num < 10 ? this.options.timeFormatSingleDigit + num : num.toString();
    };
    if (this.options.showDays && this.daysElement) {
      this.daysElement.textContent = formatDigits(days);
    }
    if (this.hoursElement) this.hoursElement.textContent = formatDigits(hours);
    if (this.minutesElement) this.minutesElement.textContent = formatDigits(minutes);
    if (this.secondsElement) this.secondsElement.textContent = formatDigits(seconds);
  }
}
document.addEventListener("DOMContentLoaded", function () {
  const countdownOptions = window.saleCountdownOptions || {};
  new SaleCountdown(countdownOptions);
});
